var _path, _circle, _circle2, _circle3, _circle4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeclockRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Time Clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.05.08H1A.87.87,0,0,0,.08,1v13.1a.87.87,0,0,0,.87.87h13.1a.87.87,0,0,0,.87-.87V1A.87.87,0,0,0,14.05.08ZM7.5,13.17A5.67,5.67,0,1,1,13.17,7.5,5.67,5.67,0,0,1,7.5,13.17Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 12.11,
    r: 0.48
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 3.01,
    r: 0.48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.05,
    cy: 7.56,
    r: 0.48
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.95,
    cy: 7.8,
    r: 0.48
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.61,7.59V7.8A.21.21,0,0,1,10.4,8H7.19V4.16a.22.22,0,0,1,.22-.22h.21a.22.22,0,0,1,.22.22V7.37H10.4A.21.21,0,0,1,10.61,7.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeclockRecord);
export default __webpack_public_path__ + "static/media/timeclock_record.09bbd5a4966ddfd3265326137c416336.svg";
export { ForwardRef as ReactComponent };